






































import { Component, Vue } from "vue-property-decorator";
import Menu from "@/components/Menu.vue";
import CityService from "../services/city.service";
import Footer from "../components/Footer.vue";
@Component({
  components: {
    Menu,
    Footer,
  },
})
export default class AllBrands extends Vue {
  private service = new CityService();

  private brands: any = [];

  view(id) {
    return false;
    // this.$router.push("brand/" + id);
  }

  created() {
    this.service.getBrands().then((res) => {
      this.brands = res.data;
    });
  }
}
